<app-breadcrumbs
	[headerTitle]="'USER MANAGEMENT'"
	[buttonText]="'ADD NEW USER'"
	(onHeaderButtonAction)="addNewUser()"
	[buttonIconObj]="breadCrumbIcon"
/>

<div class="main-container">
	<div [formGroup]="searchForm">
		<mat-form-field appearance="outline">
			<app-icon [name]="'search-normal-1'" size="17" matPrefix></app-icon>
			<input id="search" matInput placeholder="Enter your search" formControlName="search" />
		</mat-form-field>
	</div>

	@if(rolesList && statusOption) {
	<div class="section flex flex-row flex-align-center-start">
		<div class="flex flex-row flex-align-center-start flex-1" style="--max-width: 65%">
			<div class="title">User List</div>
			<div class="role-select" [formGroup]="selectForm">
				<input-wrapper class="input-wrapper">
					<input-select
						id="roles"
						formControlName="select"
						[label]="'Roles'"
						[options]="rolesList | roles"
						[resetOption]="true"
					>
					</input-select>
				</input-wrapper>
			</div>
			<div [formGroup]="statusForm">
				<input-wrapper class="input-wrapper">
					<input-select
						id="status"
						formControlName="status"
						[label]="'Status'"
						[options]="statusOption"
						[resetOption]="true"
					>
					</input-select>
				</input-wrapper>
			</div>
		</div>
		<div class="flex flex-row flex-align-stretch-end flex-1" style="--max-width: 35%">
			<button
				class="menu-buttons download-users-report"
				[cdkMenuTriggerFor]="menu"
				mat-button
				(cdkMenuClosed)="isReportsMenuOpen = false"
				(cdkMenuOpened)="isReportsMenuOpen = true"
				data-test="download-reports-button"
			>
				<span class="uploadText">
					<app-icon
						class="button-icon"
						[name]="'document-download'"
						[color]="'var(--color-white)'"
						[lineWidth]="'2px'"
					></app-icon>
					<span class="text-spacing">DOWNLOAD REPORTS</span>
					<app-icon
						class="button-icon last"
						[name]="'arrow-down'"
						[color]="'var(--color-white)'"
						[lineWidth]="'2px'"
						[ngClass]="{ 'up-arrow': isReportsMenuOpen }"
					></app-icon>
				</span>
			</button>
		</div>
	</div>
	} @if (rolesList && statusOption && (userPagination$ | async); as userPagination){
	<app-user-management-table
		[dataSource]="userPagination.items"
		(editUserSelectedEvent)="editUser($event)"
		(changeStatusEvent)="toggleUser($event)"
		(showUserLogInfo)="showUserLogInfo($event)"
	></app-user-management-table>
	<mat-paginator
		id="paginator"
		[length]="userPagination.totalCount"
		[pageSizeOptions]="[5, 10, 25, 100]"
		[pageSize]="pageSize"
		[pageIndex]="userPagination.pageNumber"
		(page)="paginate($event)"
		aria-label="Select page"
	>
	</mat-paginator>
	}
</div>
@if(showLog) {
<app-user-log-list (closeLog)="closeLog()" [user]="userLog" />
}
<ng-template #menu>
	<div class="sub-menu" cdkMenu>
		<button class="user-report" cdkMenuItem (click)="downloadReport('users')" data-test="users-report-button">
			<span class="button-text">
				<span class="text-spacing">Users Report</span>
			</span>
		</button>
		<mat-divider></mat-divider>
		<button
			class="user-report"
			cdkMenuItem
			(click)="downloadReport('clientUsers')"
			data-test="client-users-report-button"
		>
			<span class="button-text">
				<span class="text-spacing">Client Users Report</span>
			</span>
		</button>
	</div>
</ng-template>
